var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"padded-space",attrs:{"id":"partner-notifications-settings-view"}},[_c('div',{staticClass:"centered-space"},[_c('h2',[_vm._v("Notifications settings (WIP)")])])])
}]

export { render, staticRenderFns }